import { drawing as d, geometry as g } from '@progress/kendo-drawing';
import { START } from '../constants';
import { MarkerBase } from './MarkerBase';
import { deepExtend } from './../utils/deep-extend';
const defaultOptions = {
    radius: 4,
    anchor: {
        x: 0,
        y: 0
    }
};
/**
 * A visual marker that renders a circle shape at the start or end of a path.
 * Extends MarkerBase to provide circle-specific positioning and rendering functionality.
 */
export class CircleMarker extends MarkerBase {
    /**
     * Creates a new CircleMarker instance.
     * @param options Configuration options for the circle marker
     */
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
    }
    /**
     * Creates the drawing element for the circle marker.
     */
    createElement() {
        const options = this.options;
        this.drawingElement = new d.Circle(new g.Circle(this.anchor, options.radius), {
            fill: options.fill,
            stroke: options.stroke
        });
    }
    /**
     * Positions the circle marker on the specified path.
     * @param path The path on which to position the circle marker
     */
    positionMarker(path) {
        const options = this.options;
        const position = options.position;
        const segments = path.segments;
        let targetSegment;
        let point;
        if (position === START) {
            targetSegment = segments[0];
        }
        else {
            targetSegment = segments[segments.length - 1];
        }
        if (targetSegment) {
            point = this._transformToPath(targetSegment.anchor(), path);
            this.drawingElement.transform(g.transform().translate(point.x, point.y));
        }
    }
}
